import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setOrderLoyaltyType, setLoyaltyEntrySource } from '@reducers/loyalty';
import OrderLoyalty from '@components/LoyaltyInOrder';

const useAddLoyalty = ({ checkData }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    dispatch(setLoyaltyEntrySource('MORE_SCREEN'));
    dispatch(setOrderLoyaltyType(1));
    setIsOpen(true);
  }, [dispatch]);

  const jsx = isOpen ? (
    <OrderLoyalty
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      check={checkData}
      currentSeat={null}
    />
  ) : null;

  return { open, jsx };
};

export default useAddLoyalty;
